import { Injectable } from '@angular/core';
import { NbAccessChecker } from '@nebular/security';
import { MemberService } from '../data/member/member.service';
import { ParamsObject } from './api.service';
import { Member } from '../models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class SecurityService {

  private currentUser: Member;

  constructor(
    private accessChecker: NbAccessChecker,
    private member: MemberService,
  ) {
    this.member.currentUser.subscribe(currentUser => {
      if (currentUser) {
        this.currentUser = currentUser;
      }
    });
  }

  /**
   * Uses NbAccessChecker.isGranted to return past query parameters
   * enriched with the user's ID or not. This to specify whether
   * we must access all the content or only that of the owner.
   *
   * @param permission
   * @param resource
   * @param params
   */
  allOrMeContent(permission: string, resource: string, params: ParamsObject): Observable<ParamsObject> {
    return this.accessChecker.isGranted(permission, resource)
      .pipe(map(granted => {
        if (!granted) {
          params.owner = this.currentUser.id;
        }
        return params;
      }));
  }
}
